export default __webpack_public_path__ + "static/media/Unity3D.a0819563.png";